import ProfilContainer from "./MainContainer"


function ProfilPage(){
    return(
        <div>
            <ProfilContainer />
        </div>
    )
}

export default ProfilPage